<template>
  <div>
    <span v-show="loading" class="spinner-border spinner-border-xl"></span>

    <div class="message">
      <div class="message-body">
        <div role="log" class="conversations">
          <ul id="conversationList" class="conversation-list">
            <li
              v-for="comment in commentList"
              :key="comment.dokumentKomentarId"
              class="conversation-inbound"
            >
              <div class="conversation-avatar">
                <a class="tile tile-circle bg-teal">{{comment.imeZacetnice}}</a>
              </div>
              <div class="conversation-message">
                <div class="conversation-message-text">{{comment.vsebina}}</div>
                <div class="conversation-meta">{{comment.prikaznoIme}} · {{ formatDate(comment.vnosDatum)}}</div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="message-publisher">
        <form  @submit.prevent="insertComment" method="post" id="commentForm">
          <div class="media mb-1">
            <div class="media-body">
              <input
                v-model="comment"
                type="text"
                class="form-control border-0 shadow-none"
                name="Vsebina"
                placeholder="Vnesite komentar"
              />
            </div>
            <div>
              <button type="submit" class="btn btn-light btn-icon">
                <b-icon icon="reply" aria-hidden="true"></b-icon>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div v-if="message" class="alert alert-danger" role="alert">{{message}}</div>
  </div>
</template>

<script>
import DokumentService from "../services/dokument.service";
import moment from "moment";

export default {
  name: "CommentPage",
  props: {
    dokumentId: String,
  },
  data() {
    return {
      comment: "",
      commentList: [],
      message: "",
      loading: false,
    };
  },
  methods: {
    loadComments() {
      this.loading = true;
      DokumentService.getComments(this.dokumentId).then(
        (response) => {
          this.commentList = response.data;
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          this.message =
            "Prišlo je do napake! Poskusite ponovno čez nekaj minut.";
        }
      );
    },
    insertComment() {
      DokumentService.insertComment(parseInt(this.dokumentId), this.comment).then(
        (response) => {
          this.commentList.push(response.data);
          this.comment = ''
        },
        (error) => {
          this.loading = false;
          this.message =
            "Prišlo je do napake! Poskusite ponovno čez nekaj minut.";
        }
      );
    },
    formatDate(date) {
        return moment(date).format("DD.MM.YYYY HH:MM")
    }
  },
  mounted() {
    this.loadComments();
  },
};
</script>

<style scoped>

.conversation-list {
    max-height: 75vh;
}
</style>
